import axios from 'axios';
import BaseAPI from './base/base-api';

class layoutAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'layoutconfig';
}

export default new layoutAPI();